import { getAlertStatus, getUserNameFromLC } from '../../../../services/util';
import { normalizeAlertScore } from '../../../../util/normalization';
import { getSelectedResources } from '../../../../util/resourceManager';

import { isEmpty } from '../../../../util/lodashlike';
const { tmResources } = getSelectedResources();

/**
 * getRoleOfLoggedInUser
 * @returns {{isAnalyst: boolean, isSuperVisor: boolean}}
 */
export const getRoleOfLoggedInUser = () => {
  let resourcesData = {};
  let isSuperVisor = false;
  let isAnalyst = false;
  try {
    resourcesData = JSON.parse(localStorage.getItem('persist:root'));
    const { authentication } = resourcesData || {};
    const authenticationData = JSON.parse(authentication);
    const { data: authData } = authenticationData;
    authData.map((item) => {
      const { details } = item || {};
      const { resource } = details || {};
      const { operations } = resource || {};
      const scopes = operations || [];
      if (
        scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT)
      ) {
        isSuperVisor = true;
      } else if (
        scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_ANOMALY_INVESTIGATION)
      ) {
        isAnalyst = true;
      }
    });
  } catch (e) {
    // do nothing
  }
  return {
    isSuperVisor,
    isAnalyst
  };
};

/**
 * getPermissionConfig
 * @param widgetName
 * @param headerAlertDetailObject
 * @param isSuperVisor
 * @param isAnalyst
 * @returns {{isReadOnly: boolean, isDisabled: boolean, isWrite: boolean, isHidden: boolean}}
 */
export const getPermissionConfig = ({
  widgetName,
  headerAlertDetailObject,
  isSuperVisor,
  isAnalyst
}) => {
  const { alert_type, alertStatus } = headerAlertDetailObject || {};
  if (alert_type === 'ANOMALY' || alert_type === 1) {
    // Only for Anomaly
    if (isSuperVisor) {
      switch (alertStatus) {
        case 0: // OPEN
        case 2: // ASSIGNED
        case 3: // UNDER INVESTIGATION
          if (widgetName === 'SupervisorReviewWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          if (widgetName === 'AnomalyDispositionWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          if (widgetName === 'AnalystEditorModalWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          if (widgetName === 'SuperVisorEditorModalWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          break;

        case 4: //PENDING APPROVAL
          if (widgetName === 'SupervisorReviewWidget') {
            return {
              isReadOnly: false,
              isWrite: true,
              isHidden: false,
              isDisabled: false
            };
          }
          if (widgetName === 'AnomalyDispositionWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'AnalystEditorModalWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'SuperVisorEditorModalWidget') {
            return {
              isReadOnly: false,
              isWrite: true,
              isHidden: false,
              isDisabled: false
            };
          }
          break;

        case 1: //CLOSED
          if (widgetName === 'SupervisorReviewWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          if (widgetName === 'AnomalyDispositionWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'AnalystEditorModalWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'SuperVisorEditorModalWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          break;
      }
    }
    if (isAnalyst) {
      if (
        String(headerAlertDetailObject.analystName).trim().toUpperCase() !==
        String(getUserNameFromLC()).trim().toUpperCase()
      ) {
        return {
          isReadOnly: false,
          isWrite: false,
          isHidden: true,
          isDisabled: true
        };
      }
      switch (alertStatus) {
        case 2: // ASSIGNED
        case 3: // UNDER INVESTIGATION
          if (widgetName === 'SupervisorReviewWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          if (widgetName === 'AnomalyDispositionWidget') {
            return {
              isReadOnly: false,
              isWrite: true,
              isHidden: false,
              isDisabled: false
            };
          }
          if (widgetName === 'AnalystEditorModalWidget') {
            return {
              isReadOnly: false,
              isWrite: true,
              isHidden: false,
              isDisabled: false
            };
          }
          if (widgetName === 'SuperVisorEditorModalWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          break;

        case 4: //PENDING APPROVAL
          if (widgetName === 'SupervisorReviewWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          if (widgetName === 'AnomalyDispositionWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'AnalystEditorModalWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'SuperVisorEditorModalWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          break;

        case 1: //CLOSED
          if (widgetName === 'SupervisorReviewWidget') {
            return {
              isReadOnly: false,
              isWrite: false,
              isHidden: true,
              isDisabled: false
            };
          }
          if (widgetName === 'AnomalyDispositionWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'AnalystEditorModalWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          if (widgetName === 'SuperVisorEditorModalWidget') {
            return {
              isReadOnly: true,
              isWrite: false,
              isHidden: false,
              isDisabled: true
            };
          }
          break;
      }
    }
    return {
      isReadOnly: false,
      isWrite: false,
      isHidden: true,
      isDisabled: true
    };
  }
  return {
    isReadOnly: false,
    isWrite: false,
    isHidden: true,
    isDisabled: true
  };
};
/**
 * getHeaderData
 * @param headerAlertDetailObject
 * @returns {{alertStatus: string, score: number, alert_id: string, alertDate: string, alert_level: string, alert_type: string}}
 */
export const getHeaderData = (headerAlertDetailObject) => {
  const alert_type = headerAlertDetailObject
    ? headerAlertDetailObject['alert_type']
    : '';
  const alert_level =
    headerAlertDetailObject?.['alert_level'] &&
    headerAlertDetailObject['alert_level'] !== 'null'
      ? headerAlertDetailObject['alert_level']
      : '';
  const alert_id = headerAlertDetailObject
    ? headerAlertDetailObject['alert_id']
    : '';
  const alertDate = headerAlertDetailObject
    ? headerAlertDetailObject['alertDate']
    : '';
  const score =
    headerAlertDetailObject && !isNaN(headerAlertDetailObject.score)
      ? headerAlertDetailObject.score
      : 0;
  const alertStatus = getAlertStatus(headerAlertDetailObject.alertStatus);
  const rules = headerAlertDetailObject?.['rules']
    ? headerAlertDetailObject['rules']
    : [];
  return {
    alert_type,
    alert_level,
    alert_id,
    alertDate,
    score,
    alertStatus,
    rules
  };
};

/**
 * This accepts props and state as params and tries
 * to figure out the available file and ID via all possible means
 * @param props
 * @param state
 * @returns {{isAvailable: boolean, attachmentName: string, attachmentID: string}}
 */
export const getFileNameAndID = (props, state) => {
  const { headerAlertDetailObject } = props || {};
  let newAttachmentId = '';
  let newAttachmentName = '';
  if (!isEmpty(headerAlertDetailObject)) {
    const { attachmentId = '', attachmentName = '' } =
      headerAlertDetailObject || {};
    newAttachmentId = attachmentId;
    newAttachmentName = attachmentName;
  }
  if (isEmpty(newAttachmentId) && isEmpty(newAttachmentName)) {
    const { fileID = '', selectedFile = {} } = state || {};
    if (!isEmpty(fileID) && selectedFile !== null) {
      newAttachmentId = fileID;
      newAttachmentName = selectedFile.name;
    }
  }
  if (isEmpty(newAttachmentName) && isEmpty(newAttachmentId)) {
    return {
      attachmentName: '',
      attachmentID: '',
      isAvailable: false
    };
  } else {
    return {
      attachmentName: newAttachmentName,
      attachmentID: newAttachmentId,
      isAvailable: true
    };
  }
};

/**
 * Get Analyst and Supervisor Perms for EDITOR WIDGET
 * @param analystEditorModalWidgetPerm
 * @param superVisorEditorModalWidgetPerm
 * @returns {{isAnReadOnly, isAnDisabled, isSuWrite, isSuDisabled, isAnWrite, isAnHidden, isSuReadOnly, isSuHidden}}
 */
export const getAnalystSupervisorPerms = (
  analystEditorModalWidgetPerm,
  superVisorEditorModalWidgetPerm
) => {
  const {
    isWrite: isAnWrite,
    isReadOnly: isAnReadOnly,
    isHidden: isAnHidden,
    isDisabled: isAnDisabled
  } = analystEditorModalWidgetPerm || {};
  const {
    isWrite: isSuWrite,
    isReadOnly: isSuReadOnly,
    isHidden: isSuHidden,
    isDisabled: isSuDisabled
  } = superVisorEditorModalWidgetPerm || {};

  return {
    isAnWrite,
    isAnReadOnly,
    isAnHidden,
    isAnDisabled,
    isSuWrite,
    isSuReadOnly,
    isSuHidden,
    isSuDisabled
  };
};
